module.exports = __webpack_public_path__ + "img/stats.03132aae.png";